import { TASK_TYPE, ACTION_TYPE } from "../constants";
import { FlowService } from "../services/flow.service";
import { PencilModeAdapter } from "../adapters/pencilMode.adapter";

export const initWhiteBoard = (flowId, hostName, theme) => async next => {
  const flowService = new FlowService(hostName, flowId);
  const { items } = await flowService.readFlow();

  const pencilModeAdapter = new PencilModeAdapter();
  let modes = items.map(item => {
    return pencilModeAdapter.getMode(item);
  });

  next({
    type: TASK_TYPE.INIT_WHITEBOARD,
    payload: { modes, flowId, hostName, theme }
  });
};

export const chooseModeType = modeType => {
  return {
    type: TASK_TYPE.CHOOSE_MODE_TYPE,
    payload: { modeType }
  };
};

export const addMode = (data, id, type) => (next, getState) => {
  const { classId, selectedPageId, flowId, hostName } = getState().modeReducer;

  const flowService = new FlowService(hostName, flowId);
  flowService.pushToServer(data, id, type, flowId, classId, selectedPageId);

  next({
    type: ACTION_TYPE.ADD_MODE,
    payload: {
      data,
      id,
      type,
      selectedPageId
    }
  });
};

export const performUndo = () => (next, getState) => {
  let { flowId, hostName, modes, selectedPageId } = getState().modeReducer;

  let modesWithinPage = modes.filter(mode => {
    return mode.selectedPageId === selectedPageId;
  });

  let removedMode = modesWithinPage.pop();

  if (typeof removedMode === "undefined") return;

  let { id } = removedMode;

  const flowService = new FlowService(hostName, flowId);
  flowService.removeFromServer(flowId, id);

  modes = modes.filter(mode => {
    return mode.id !== id;
  });

  next({ type: TASK_TYPE.PERFORM_UNDO, payload: { modes } });
};

export const changePageNumber = pageNumber => {
  return { type: TASK_TYPE.CHANGE_PAGE_NUMBER, payload: { pageNumber } };
};

export const clearAll = () => (next, getState) => {
  let { flowId, hostName, modes, selectedPageId } = getState().modeReducer;
  let modesWithinPage = modes.filter(mode => {
    return mode.selectedPageId === selectedPageId;
  });

  let modeIdsToRemove = modesWithinPage.map(mode => {
    return mode.id;
  });

  const flowService = new FlowService(hostName, flowId);
  flowService.removeMultipleFromServer(flowId, modeIdsToRemove);

  modes = modes.filter(mode => {
    return modeIdsToRemove.indexOf(mode.id) < 0;
  });

  next({ type: TASK_TYPE.CLEAR_ALL, payload: { modes } });
};
